// 在組 payload 的同一時間更新 map 與 ord，避免條件顯隱後沿用選取時的快照。
export function refreshMultipleChoiceOrder(question, choiceIndexMapRef, choicesOrderRef) {
  if (!question || !(question.getType() === 'checkbox' ||
    (question.getType() === 'imagepicker' && question.multiSelect))) return
  const choices = question.visibleChoices
  const previous = choiceIndexMapRef.current[question.name] || {}
  const map = { ...previous }
  const isBringIn = Boolean(previous[0]?.title)
  const ord = choices.map((choice, index) => {
    const old = previous[choice.value]
    // 保留帶入題的來源資訊，僅更新顯示位置。
    map[choice.value] = old && typeof old === 'object' && old.title
      ? { ...old, index }
      : index
    return isBringIn || choice.value === 'none' || choice.value === 'other' ? index : choice.value
  })
  choiceIndexMapRef.current[question.name] = map
  choicesOrderRef.current[question.name] = ord
}

// 帶入題的 payload 選項按當下畫面順序排列，與 ans / identity ord 同步。
export function getBringInPayloadSlots(question, map = {}) {
  const multiple = question?.getType() === 'checkbox' ||
    (question?.getType() === 'imagepicker' && question.multiSelect)
  const slots = multiple ? question.visibleChoices.map(choice => map[choice.value]) : Object.values(map)
  return slots.filter(slot => slot && slot.title)
}
